/**
 * Reads the non-httpOnly csrfToken cookie set by the backend on login/refresh
 * so it can be echoed back as the X-CSRF-Token header on mutating requests
 * (see CsrfGuard on the backend).
 */
export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)csrfToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
